import * as constants from './constants';
import * as g_constants from '../../global/constants';

const initialState = {
  selectedBooking: null,
  bookings: [],
  listingBookings: []
};

export default function Booking(state = initialState, action) {
  switch (action.type) {
    case constants.SET_SELECTED_BOOKING:
      return Object.assign({}, state, {
        selectedBooking: action.data
      });
    case constants.RESET_BOOKINGS_LIST:
      return Object.assign({}, state, {
        bookings: []
      });
    case constants.SET_BOOKINGS_LIST:
      //If array is empty; set
      if (state.bookings === undefined) { state.bookings = []; }
      if (state.bookings && !state.bookings.length)
        return Object.assign({}, state, {
          bookings: action.data
        });
      //If elements exist perform an upsert
      action.data.forEach(b => {
        let indexOfBooking = state.bookings.map(b => b._id).indexOf(b._id);
        if (indexOfBooking > -1) { state.bookings.splice(indexOfBooking, 1, b) }
        else { state.bookings.push(b) }
      });
      return Object.assign({}, state, {
        bookings: state.bookings.slice(0)
      })
    case constants.SET_LISTINGBOOKINGS_LIST:
      return Object.assign({}, state, {
        listingBookings: action.data
      });
    case constants.SET_BOOKINGS_REPLACEONE:
      if (state.bookings === undefined) { state.bookings = []; }
      let indexOfBooking = state.bookings.map((b) => b._id).indexOf(action.data._id);
      if (indexOfBooking > -1)
        state.bookings.splice(indexOfBooking, 1, action.data);
      else
        state.bookings.push(action.data);
      return Object.assign({}, state, {
        bookings: state.bookings.slice(0)
      });
    case constants.SET_LISTINGBOOKINGS_REPLACEONE:
      if (state.listingBookings === undefined) { state.listingBookings = []; }
      let indexOfListingBooking = state.listingBookings.map((b) => b._id).indexOf(action.data._id);
      if (indexOfListingBooking > -1) {
        state.listingBookings.splice(indexOfListingBooking, 1, action.data);
      } else {
        state.listingBookings.push(action.data);
      }
      return Object.assign({}, state, {
        listingBookings: state.listingBookings.slice(0)
      });
    case g_constants.IMPERSONATE:
    case g_constants.LOGOUT:
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
